import { render, staticRenderFns } from "./LookRport.vue?vue&type=template&id=24ee245a&scoped=true&"
import script from "./LookRport.vue?vue&type=script&lang=js&"
export * from "./LookRport.vue?vue&type=script&lang=js&"
import style0 from "./LookRport.vue?vue&type=style&index=0&id=24ee245a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee245a",
  null
  
)

export default component.exports